export const environment = {
     wrUrl: 'http://172.16.50.12:2002/',
     apiUrl: 'http://172.16.50.12:2000/',
     mongoUrl: 'https://apidocs.enerser.com.mx/',
     isTest:false,
     isQA:true,
     xigaMovil:'https://est-dv.ener-go.mx/',
     apiInvoicing: 'http://10.255.248.54:443/api/',
     multipagos_url:'https://prepro.adquiracloud.mx/clb/endpoint/gasmart',
     urlForward:'http://172.16.50.12:2000/Payment/Payment-done',
      wasabiUrl: 'http://10.255.248.68:3002',
    wasabiApiKey: '2166d34d0b291f92110a05a7e9ff3169019a94b2319ff98d2bb54980c74766a8',
    apiKey:'F08DEF714F0B7954:66B8B72DE206A76F8BA2ABF254F1F85EC9698471A87B2B4A17D8B14326EC4402'
 
};
